var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"gameBlocks"},_vm._l((_vm.games),function(game,index){return _c('game-block',{key:game.text,attrs:{"text":game.text,"type":game.type,"color":game.color,"amount":_vm.games.length,"number":index,"logo":game.logo,"levels":game.levels}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }